/* ============
 * Edi Order Module Mutations
 * ============
 */

import {
  FETCH_PAGINATED_EDI_ORDERS,
  FETCH_ALL_EDI_ORDERS,
  FETCH_CURRENT_EDI_ORDER,
  RESET_CURRENT_EDI_ORDER,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_EDI_ORDERS](state, { ediOrders, pagination }) {
    state.items = ediOrders;
    state.pagination = pagination;
  },

  [FETCH_ALL_EDI_ORDERS](state, ediOrders) {
    state.all = ediOrders;
  },

  [FETCH_CURRENT_EDI_ORDER](state, ediOrder) {
    state.currentEdiOrder = ediOrder;
  },

  [RESET_CURRENT_EDI_ORDER](state) {
    state.currentEdiOrder = {};
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/ediOrder/mutations.js